import { useState } from "react";

export default function SettingsPage() {
  const [form, setForm] = useState({
    name: "Admin User",
    email: "admin@mekpay.com",
    password: "",
  });

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  return (
    <div className="mx-auto flex w-full max-w-5xl flex-col gap-6 p-4 md:p-6">
      <section className="rounded-[2rem] border border-white/10 bg-slate-900/75 p-6 text-white shadow-2xl shadow-cyan-500/10 backdrop-blur">
        <p className="text-xs uppercase tracking-[0.3em] text-cyan-200/80">Admin Profile</p>
        <h1 className="mt-2 text-2xl font-semibold md:text-3xl">Admin Settings</h1>
        <p className="mt-2 text-sm text-slate-300">Manage your profile details and account access credentials.</p>
      </section>

      <form className="space-y-6 rounded-[2rem] border border-white/10 bg-slate-900/70 p-6 text-white shadow-2xl shadow-black/30 backdrop-blur">
        <div>
          <label className="mb-2 block text-sm font-medium text-slate-300">Full Name</label>
          <input
            type="text"
            name="name"
            value={form.name}
            onChange={handleChange}
            className="w-full rounded-xl border border-white/15 bg-slate-800/70 px-4 py-2.5 text-white placeholder:text-slate-500 focus:border-cyan-300/60 focus:outline-none"
          />
        </div>

        <div>
          <label className="mb-2 block text-sm font-medium text-slate-300">Email</label>
          <input
            type="email"
            name="email"
            value={form.email}
            onChange={handleChange}
            className="w-full rounded-xl border border-white/15 bg-slate-800/70 px-4 py-2.5 text-white placeholder:text-slate-500 focus:border-cyan-300/60 focus:outline-none"
          />
        </div>

        <div>
          <label className="mb-2 block text-sm font-medium text-slate-300">Change Password</label>
          <input
            type="password"
            name="password"
            placeholder="New password"
            value={form.password}
            onChange={handleChange}
            className="w-full rounded-xl border border-white/15 bg-slate-800/70 px-4 py-2.5 text-white placeholder:text-slate-500 focus:border-cyan-300/60 focus:outline-none"
          />
        </div>

        <button
          type="button"
          className="rounded-xl border border-cyan-300/30 bg-cyan-500/20 px-6 py-2.5 text-sm font-medium text-cyan-100 transition hover:bg-cyan-500/30"
        >
          Save Changes
        </button>
      </form>
    </div>
  );
}
